module.exports = __webpack_public_path__ + "img/nl-fr.5a34c3eb.svg";